import React from 'react';
import PropTypes from 'prop-types';
import ApolloQuery from '../../../../modules/react/components/stateful/ApolloQuery';

const propTypes = {
  children: PropTypes.func.isRequired,
  facilities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  primaryFacilityId: PropTypes.string,
};

const defaultProps = {
  primaryFacilityId: undefined,
};

const PrimaryFacilityQuery = ({
  children,
  facilities,
  primaryFacilityId,
  ...rest
}) => {
  if (!primaryFacilityId) {
    return children(facilities);
  }

  const primaryFacilityIndex = facilities.findIndex(facility => (
    facility.id === primaryFacilityId
  ));

  if (primaryFacilityIndex > -1) {
    return children(facilities);
  }

  return (
    <ApolloQuery {...rest}>
      {({ facility }) => children([
        { ...facility, primary: true },
        ...facilities,
      ])}
    </ApolloQuery>
  );
};

PrimaryFacilityQuery.propTypes = propTypes;
PrimaryFacilityQuery.defaultProps = defaultProps;

export default PrimaryFacilityQuery;
